module.exports = __webpack_public_path__ + "img/ic_google.463239e2.svg";